<template>
  <v-card class="card" color="primary">
    <v-card-title class="d-flex justify-center align-center">
      <div class="text-h5 font-weight-bold">Nuevos Ingresos</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <BaseInput v-model="search" label="Buscar" append-icon="mdi-magnify" style="max-width: 300px" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="personal" class="transparent">
                  <template v-slot:[`item.nombre`]="{ item }">
                    {{ getFullName(item) }}
                  </template>
                  <template v-slot:[`item.puesto`]="{ item }">
                    {{
                      item.CatPuestoDependencia && item.CatPuestoDependencia.catPuesto
                        ? item.CatPuestoDependencia.catPuesto.title
                        : ''
                    }}
                  </template>
                  <template v-slot:[`item.CUP`]="{ item }">
                    <span>
                      {{ item.CUP ? item.CUP : 'Sin datos' }}
                    </span>
                  </template>
                  <template v-slot:[`item.opciones`]="{}">
                    <span class="d-flex align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton class="mr-2" variant="secondary" icon="mdi-card-account-details-outline" />
                          </span>
                        </template>
                        <span>Ver detalle</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import IconButton from '../../base/IconButton.vue'
import BaseInput from '../../base/BaseInput.vue'
import TextButton from '../../base/TextButton.vue'

export default {
  components: {
    IconButton,
    BaseInput,
    TextButton,
  },
  data() {
    return {
      headers: [
        { text: 'Nombre', value: 'nombre', width: '250px' },
        { text: 'Puesto', value: 'puesto', width: '250px' },
        { text: 'CUIP', value: 'CUIP', width: '150px' },
        { text: 'CUP', value: 'CUP', width: '150px' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: '150px' },
      ],
      loading: false,
      search: '',
    }
  },
  computed: {
    ...mapGetters('personal', {
      personalOriginal: 'getPersonalWithArmas',
    }),
    personal() {
      if (!this.search) return this.personalOriginal
      const searchLower = this.search.toLowerCase()
      return this.personalOriginal.filter((item) => {
        const nombreCompleto = this.getFullName(item).toLowerCase()
        const puesto =
          item.CatPuestoDependencia && item.CatPuestoDependencia.catPuesto
            ? item.CatPuestoDependencia.catPuesto.title.toLowerCase()
            : ''
        return nombreCompleto.includes(searchLower) || puesto.includes(searchLower)
      })
    },
  },
  methods: {
    getFullName(person) {
      if (!person) return ''
      if (person.segundoNombre == '') {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.nombre
      } else {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.nombre + ' ' + person.segundoNombre
      }
    },
  },
  created() {
    this.$store.dispatch('personal/fetchPersonalWithArmas')
  },
}
</script>

<style scoped>
/* Card principal con glass morphism */
.card {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1);
  transition: all 0.3s ease;
}

.card:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
  box-shadow: 0 8px 32px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.15);
}

/* Data table con estilos modernos */
::v-deep .v-data-table {
  background: transparent !important;
  border-radius: 8px;
  overflow: hidden;
}

/* Headers de tabla con colores dinámicos */
::v-deep .v-data-table thead th {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.15) !important;
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3) !important;
  padding: 16px !important;
}

/* Rows de tabla */
::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
  border-radius: 8px;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
  transform: scale(1.005);
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.2);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
  padding: 16px !important;
}

/* Tooltips con colores dinámicos */
::v-deep .v-tooltip__content {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.95) !important;
  color: #1a1a1a !important;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
}

/* Botones con efectos modernos */
::v-deep .v-btn {
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6) !important;
}

::v-deep .v-btn:active {
  transform: translateY(0);
}

::v-deep .v-btn.v-btn--icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn.v-btn--icon:hover {
  transform: scale(1.2) rotate(5deg);
}

/* Loading state */
::v-deep .v-data-table__progress {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
}

::v-deep .v-data-table__progress .v-progress-linear__determinate {
  background: var(--v-secondary-base) !important;
}

::v-deep .v-progress-linear__indeterminate .v-progress-linear__indeterminate--active .long {
  background: var(--v-secondary-base) !important;
}

::v-deep .v-progress-linear__indeterminate .v-progress-linear__indeterminate--active .short {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.7) !important;
}

/* Empty state */
::v-deep .v-data-table__empty-wrapper {
  color: rgba(255, 255, 255, 0.6) !important;
  font-style: italic;
}

/* Footer de tabla */
::v-deep .v-data-footer {
  border-top: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.2) !important;
  background: transparent !important;
}

::v-deep .v-data-footer__select .v-select__selection {
  color: rgba(255, 255, 255, 0.9) !important;
}

::v-deep .v-data-footer__pagination {
  color: rgba(255, 255, 255, 0.9) !important;
}

/* Iconos de paginación */
::v-deep .v-data-footer .v-btn--icon {
  color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.8) !important;
}

::v-deep .v-data-footer .v-btn--icon:hover {
  color: var(--v-secondary-base) !important;
}

/* Scrollbar personalizado */
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
  border-radius: 4px;
  transition: background 0.3s ease;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6);
}

/* Card loading overlay */
::v-deep .v-card__progress {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
}

::v-deep .v-card__progress .v-progress-linear__determinate {
  background: var(--v-secondary-base) !important;
}

/* Animación de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: fadeInUp 0.6s ease-out;
}
</style>
